import React from 'react';
import HostInfo from './HostInfo';
import style from '../style.module.scss';

const HostInfoRow = ({ cameras }) => (
  <>
    <tr>
      <td colSpan={cameras.length + 1} className={style.ThemeYellowBackground}>
        Controller
      </td>
    </tr>
    <tr className={style.TopLabel}>
      <td className={style.SideLabel}>Host Info</td>
      {cameras.map((camera) => (
        <td key={camera._id}>
          <HostInfo camKey={camera.cameraKey} />
        </td>
      ))}
    </tr>
    <tr
      className={`${style.TopLabel} ${new Set(cameras.map((c) => c?.cameraSettings?.gitVersion || 'No Info Available')).size > 1 ? style.rowMismatch : ''}`.trim()}
    >
      <td className={style.SideLabel}>Git Version</td>
      {cameras.map((camera) => {
        const gitVersion = camera?.cameraSettings?.gitVersion || 'No Info Available';
        return (
          <td key={`git-version-${camera._id}`} style={{ maxWidth: '230px' }}>
            <div className="form-group">
              <div className="form-row">
                <pre
                  className="m-0 text-right"
                  style={{
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    display: 'block',
                    width: '100%',
                  }}
                  title={gitVersion}
                >
                  {gitVersion}
                </pre>
              </div>
            </div>
          </td>
        );
      })}
    </tr>
  </>
);

export default HostInfoRow;
